/**
 * API Keys Configuration
 * 
 * IMPORTANT: This file should be gitignored in production environments.
 * API keys should be loaded from environment variables or a secure vault.
 * This implementation is for development purposes only.
 * 
 * To set up your OpenAI API key:
 * 1. Create a .env file in the root directory if it doesn't exist
 * 2. Add the following line to your .env file:
 *    REACT_APP_OPENAI_API_KEY=your-openai-api-key-here
 * 3. Restart your development server
 * 
 * Note: The API key should start with 'sk-' or 'sk-proj-'
 */

// Log environment variable status (safely) - DEVELOPMENT ONLY
const logApiKeyStatus = (key, value) => {
  // Only log in development environment
  if (process.env.NODE_ENV === 'development') {
    if (!value || value === '') {
      console.warn(`Warning: ${key} is not set`);
    } else if (value.startsWith('your-') || value.includes('api-key-here')) {
      console.warn(`Warning: ${key} is using default placeholder value`);
    } else {
      console.log(`${key} is configured`);
    }
  }
};

// Check OpenAI API key
const openaiKey = process.env.REACT_APP_OPENAI_API_KEY || '';
logApiKeyStatus('REACT_APP_OPENAI_API_KEY', openaiKey);

const apiKeys = {
  /**
   * OpenAI API configuration
   */
  openai: {
    apiKey: openaiKey,
    organization: process.env.REACT_APP_OPENAI_ORG_ID || null,
  },
  
  /**
   * Anthropic API configuration (Claude)
   */
  anthropic: {
    apiKey: process.env.REACT_APP_ANTHROPIC_API_KEY || 'your-anthropic-api-key-here',
  },

  /**
   * Google Gemini API configuration
   */
  gemini: {
    apiKey: process.env.REACT_APP_GEMINI_API_KEY || 'your-gemini-api-key-here',
    endpoint: process.env.REACT_APP_GEMINI_ENDPOINT || 'https://generativelanguage.googleapis.com/v1beta'
  },

  /**
   * Hugging Face API configuration
   * For accessing open-source models like Llama, Mistral, etc.
   */
  huggingface: {
    apiKey: process.env.REACT_APP_HUGGINGFACE_API_KEY || 'your-huggingface-api-key-here',
    endpoint: process.env.REACT_APP_HUGGINGFACE_ENDPOINT || 'https://api-inference.huggingface.co/models'
  },

  /**
   * DeepSeek API configuration
   */
  deepseek: {
    apiKey: process.env.REACT_APP_DEEPSEEK_API_KEY || 'your-deepseek-api-key-here',
    endpoint: process.env.REACT_APP_DEEPSEEK_ENDPOINT || 'https://api.deepseek.com/v1'
  },

  /**
   * Cohere API configuration
   */
  cohere: {
    apiKey: process.env.REACT_APP_COHERE_API_KEY || 'your-cohere-api-key-here'
  },

  /**
   * Ollama configuration (for local open-source models)
   */
  ollama: {
    endpoint: process.env.REACT_APP_OLLAMA_ENDPOINT || 'http://localhost:11434/api'
  }
};

export default apiKeys;
